export default {
  en: "English (انجليزي)",
  ar: "Arabic (عربي)"
}
